import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { Form, Input, Button } from 'antd';
import classNames from 'classnames/bind';
import { getExistRule, validator } from 'utils/validateMessagesUtil';
import { updateUserPassword } from '../../flow/action';
import styles from '../index.less';

const cx = classNames.bind(styles);
const FormItem = Form.Item;

class ResetPasswordForm extends React.Component {
  handleSubmit = e => {
    e.preventDefault();
    const {
      email,
      token,
      form,
      intl,
      updateUserPassword,
      history
    } = this.props;
    const { formatMessage } = intl;
    form.validateFields((err, values) => {
      if (!err) {
        const { password, confirmPassword } = values;
        if (password !== confirmPassword) {
          form.setFields({
            confirmPassword: {
              value: confirmPassword,
              errors: [new Error(formatMessage({ id: 'page.Auth.confirmPasswordError' }))],
            },
          });
        } else {
          updateUserPassword(email, password, confirmPassword, token, username => history.push(`/auth/resetSuccessfully?username=${username}`));
        }
      }
    });
  }

  render() {
    const { form, intl } = this.props;
    const { locale } = intl;
    const { getFieldDecorator } = form;

    return (
      <Form className="mt-xlg" onSubmit={this.handleSubmit}>
        <FormattedMessage id="page.Auth.newPassword">
          {text => <span className={cx('resetPassword-form-label')}>{text}</span>}
        </FormattedMessage>
        <FormItem>
          {getFieldDecorator('password', {
              rules: [
                getExistRule('required', 'password', locale, { required: true }),
                {
                  validator: validator.password(locale),
                }
              ],
            })(
              <Input type="password" className={cx('resetPassword-form-input')} />
            )
          }
        </FormItem>
        <FormattedMessage id="page.Auth.confirmPassword">
          {text => <span className={cx('resetPassword-form-label')}>{text}</span>}
        </FormattedMessage>
        <FormItem>
          {getFieldDecorator('confirmPassword', {
            rules: [
              getExistRule('required', 'password', locale, { required: true }),
            ],
            })(
              <Input type="password" className={cx('resetPassword-form-input')} />
            )
          }
        </FormItem>
        <FormItem>
          <Button type="primary" htmlType="submit" className={cx('signInBtn')}>
            <FormattedMessage id="page.Auth.submitBtn" />
          </Button>
        </FormItem>
      </Form>
    );
  }
}

const mapDispatchToProps = {
  updateUserPassword
};

const Enhancer = compose(
  withRouter,
  connect(null, mapDispatchToProps),
  injectIntl,
);

export default Form.create()(Enhancer(ResetPasswordForm));



// WEBPACK FOOTER //
// ./src/views/Auth/ResetPassword/components/ResetPasswordForm.jsx